export default __webpack_public_path__ + "static/media/butler.1813474f.svg";